import React from "react";
import "./select.web.css";

function Select() {
  console.log("Text Selectability on");
  return <></>;
}

export default Select;
